export const STATUS_COLORS = {
  DEFAULT: '#999999',
  ERROR: '#D41D11',
  INFO: '#6D94CF',
  SUCCESS: '#4EA14E',
  WARNING: '#F1BE04',
};
